import { buildSelector } from '@/shared/lib/store';

export const [useGetTradingPlatformSelectedAsset] = buildSelector(
    (state) => state.tradingPlatform?.selectedAsset || null,
);
